import { Bar, BarChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import { Link } from 'react-router-dom';
import { useApi } from '../hooks';
import { Chargement, MessageErreur, formatDate } from '../components/ui';
import Icone from '../components/icones';

const STATUTS_MAJ = [
  ['PENDING', 'En attente'],
  ['SUCCESS', 'Réussies'],
];

export default function TableauDeBord() {
  const { donnees, erreur, chargement } = useApi('/dashboard');
  if (erreur) return <MessageErreur erreur={erreur} />;
  if (chargement && !donnees) return <Chargement />;

  const s = donnees.statistiques;
  const tuiles = [
    ['Clients actifs', s.active_clients, 'clients'],
    ['Postes actifs', s.active_workstations, 'postes'],
    ['Licences actives', s.active_licenses, 'licence'],
    ['Licences totales', s.total_licenses, 'licence'],
    ['Logiciels', s.active_software, 'logiciels'],
    ['Mises à jour en attente', s.pending_updates, 'misesAJour'],
  ];
  const graphique = STATUTS_MAJ.map(([cle, libelle]) => ({ libelle, nombre: donnees.misesAJour[cle] || 0 }));
  const { jours, licences } = donnees.licencesBientotExpirees;

  return (
    <>
      <h1>Tableau de bord</h1>
      <div className="tuiles">
        {tuiles.map(([libelle, valeur, icone]) => (
          <div key={libelle} className={`carte tuile ${icone === 'alerte' && valeur > 0 ? 'tuile-alerte' : ''}`}>
            <div className="tuile-entete">
              <span className="muted">{libelle}</span>
              <span className="tuile-icone">
                <Icone nom={icone} />
              </span>
            </div>
            <div className="tuile-valeur">{valeur}</div>
          </div>
        ))}
      </div>

      <div className="grille-2">
        <section className="carte">
          <h2>Mises à jour par statut</h2>
          <ResponsiveContainer width="100%" height={220}>
            <BarChart data={graphique}>
              <XAxis dataKey="libelle" tick={{ fontSize: 12, fill: '#64748b' }} axisLine={false} tickLine={false} />
              <YAxis allowDecimals={false} width={32} tick={{ fontSize: 12, fill: '#64748b' }} axisLine={false} tickLine={false} />
              <Tooltip cursor={{ fill: '#eef5ff' }} contentStyle={{ borderRadius: 8, border: '1px solid #e2e8f0' }} />
              <Bar dataKey="nombre" name="Mises à jour" fill="#2f8ff6" radius={[6, 6, 0, 0]} maxBarSize={44} />
            </BarChart>
          </ResponsiveContainer>
        </section>

        <section className="carte">
          <h2>Licences expirant dans {jours} jours</h2>
          {licences.length === 0 ? (
            <p className="muted">Aucune licence n'expire bientôt.</p>
          ) : (
            <table>
              <thead>
                <tr>
                  <th>Logiciel</th>
                  <th>Client · poste</th>
                  <th>Licence</th>
                  <th>Expire le</th>
                </tr>
              </thead>
              <tbody>
                {licences.map((l) => (
                  <tr key={l.id}>
                    <td>{l.software.name}</td>
                    <td>
                      {l.workstation.client.name} · <Link to={`/postes/${l.workstation.id}`}>{l.workstation.name}</Link>
                    </td>
                    <td>{l.workstation.license.licenseKey}</td>
                    <td>{formatDate(l.expiresAt)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </section>
      </div>

      <section className="carte">
        <h2>Versions des logiciels</h2>
        {donnees.versionsLogiciels.length === 0 ? (
          <p className="muted">Aucun logiciel actif.</p>
        ) : (
          <table>
            <thead>
              <tr>
                <th>Logiciel</th>
                <th>Dernière version</th>
                <th>Version N-1</th>
              </tr>
            </thead>
            <tbody>
              {donnees.versionsLogiciels.map((l) => (
                <tr key={l.id}>
                  <td>{l.name}</td>
                  <td>
                    <Version v={l.derniere} />
                  </td>
                  <td>
                    <Version v={l.precedente} />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </section>
    </>
  );
}

/** Numéro de version suivi de sa date de sortie */
function Version({ v }) {
  if (!v) return <span className="muted">—</span>;
  return (
    <>
      <strong>{v.version}</strong>
      {v.releaseDate && <span className="muted"> · {formatDate(v.releaseDate)}</span>}
    </>
  );
}
